// @flow
import * as React from 'react'
import { compose } from 'redux'
import { auth } from 'constructor'
import LoginForm from '../component/login-form'

// Loader
import Loader from '../component/layout/loader'

import { getQueryParamsValue } from '../service/helpers'
import { login, saveAuthData } from '../service/lex/main';
import { connect } from 'react-redux';

type Props = {
  auth: any;
  loading: any;
  authActions: {
    login: (payload: {
      username: string;
      password: string;
    }) => Promise<void>;
  }
}
type State = {
  values: {
    username: string;
    password: string;
  };
  errors: {
    [key: string]: string;
  };
}

const usernameParams = getQueryParamsValue(location.search, 'username')
const passwordParams = getQueryParamsValue(location.search, 'password')

class AuthLoginFormContainer extends React.Component<Props, State> {
  state = {
    values: {
      username: usernameParams || '',
      password: passwordParams || '',
    },
    errors: {},
  }

  submit = async (event: Object) => {
    console.log('# start submit');

    const { authActions, auth, dispatch } = this.props;
    const { values } = this.state;
    localStorage.clear()
    event.preventDefault();

    console.log('! submit start login', values);

    dispatch(login(values));
    /* authActions.login(values); */

    console.log('# end submit');
  }

  onChange = (name: string, value: string) => {
    const { values } = this.state

    this.setState({
      values: {
        ...values,
        [name]: value,
      }
    })

    setTimeout(()  => {this.props.auth.error = null}, 3000);
  }

  render() {
    const { auth, isAuth, loading } = this.props
    const { values, errors } = this.state

    if (auth.isLoading) {
      return <div style={{marginLeft: 10, marginTop: 10}}>Загрузка...</div>
    }

    if (loading?.is_redirect_loading) {
      return <div
        className={'loader-overlay'} 
      >
        <Loader /> 
      </div>
    }
    return (
      <LoginForm
        isAuth={isAuth}
        onSubmit={this.submit}
        onChange={this.onChange}
        values={values}
        errors={errors}
        auth={auth}
      />
    )
  }
}

// Подключаем нужное состояние из store
const mapStateToProps = (state) => ({
  loading: state.loading,
});
export default compose(
  connect(mapStateToProps), // или connect() если без параметров
  auth.withAuth,
)(AuthLoginFormContainer);
